import { render } from "./UserRoleModal.vue?vue&type=template&id=7575d31d&ts=true"
import script from "./UserRoleModal.vue?vue&type=script&lang=ts"
export * from "./UserRoleModal.vue?vue&type=script&lang=ts"

import "./UserRoleModal.vue?vue&type=style&index=0&id=7575d31d&lang=scss"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__